import { ChangeEvent, useEffect, useState } from "react";
import { Box, Divider, Grid, MenuItem, Switch, Typography } from "@mui/material";
import { useContextContrato } from "src/Contexts/Lancamentos/Contrato/ContratosContext";
import { ICreateBorderoParcela } from "src/Contexts/Lancamentos/Contrato/ContratosTypes";
import { AppTextField } from "src/Pages/components/AppFormComponents/AppTextField";
import {
  apenasNumeros,
  FormatMoney,
  handleFormatToNumeric,
} from "src/shared/Utils/FormatMoney";
import { handleCalcAverage } from "src/shared/Utils/handleCalcAverage";
import { CardAlerts } from "src/Pages/components/CardAlerts/CardAlerts";
import { InfoOutlinedIcon } from "src/Pages/components/Icons/Icons";

export const FormReceberParcela = () => {
  const { valuesInputsBorderoParcela, setValuesInputsBorderoParcela } =
    useContextContrato();

  const [checked, setChecked] = useState(false);

  const handleChangeChecked = (event: ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  const handleCalc = handleCalcAverage({
    valorTotal: Number(
      handleFormatToNumeric(valuesInputsBorderoParcela?.valor_recebido)
    ),
    porcentagem: Number(
      valuesInputsBorderoParcela?.desconto_parcela?.replace(",", ".")
    ),
    isDesconto: true,
  });

  const total_com_desconto = valuesInputsBorderoParcela.tipo_desconto_parcela === "PERCENTUAL"
    ? FormatMoney(String(Number(handleCalc).toFixed(2)))
    : FormatMoney(
      String(
        Number(Number(apenasNumeros(valuesInputsBorderoParcela.valor_recebido)).toFixed(2)) -
        Number(Number(apenasNumeros(valuesInputsBorderoParcela.desconto_parcela)).toFixed(2))
      )
    )

  const valorCorretora = Number(String(valuesInputsBorderoParcela.total_com_desconto).replace('.', '').replace(',', '.')) * (Number(String(valuesInputsBorderoParcela.porcentagem_comissao_corretora).replace(',', '.')) / 100);
  const valorCorretor = Number(String(valuesInputsBorderoParcela.total_com_desconto).replace('.', '').replace(',', '.')) * (Number(String(valuesInputsBorderoParcela.porcentagem_comissao_corretor).replace(',', '.')) / 100);
  const valorSupervisor = Number(String(valuesInputsBorderoParcela.total_com_desconto).replace('.', '').replace(',', '.')) * (Number(String(valuesInputsBorderoParcela.porcentagem_comissao_supervisor).replace(',', '.')) / 100);
  const valorGerente = Number(String(valuesInputsBorderoParcela.total_com_desconto).replace('.', '').replace(',', '.')) * (Number(String(valuesInputsBorderoParcela.porcentagem_comissao_gerente).replace(',', '.')) / 100);

  useEffect(() => {
    setValuesInputsBorderoParcela({
      ...valuesInputsBorderoParcela,
      total_com_desconto,

      valor_comissao_corretora: FormatMoney(String(valorCorretora.toFixed(2))),
      valor_comissao_corretor: FormatMoney(String(valorCorretor.toFixed(2))),
      valor_comissao_supervisor: FormatMoney(String(valorSupervisor.toFixed(2))),
      valor_comissao_gerente: FormatMoney(String(valorGerente.toFixed(2))),
    });

  }, [
    valuesInputsBorderoParcela.valor_recebido,
    valuesInputsBorderoParcela.desconto_parcela,
    valuesInputsBorderoParcela.tipo_desconto_parcela,
    valuesInputsBorderoParcela.total_com_desconto,
  ]);

  const handleChange =
    (prop: keyof ICreateBorderoParcela, option?: "money" | "money2") =>
      (event: ChangeEvent<HTMLInputElement>) => {
        if (option === "money") {
          setValuesInputsBorderoParcela({
            ...valuesInputsBorderoParcela,
            [prop]: FormatMoney(event.target.value),
          });
        } else if (option === "money2") {
          if (event.target.value.length <= 9) {
            setValuesInputsBorderoParcela({
              ...valuesInputsBorderoParcela,
              [prop]:
                valuesInputsBorderoParcela.tipo_desconto_parcela === "VALOR"
                  ? FormatMoney(event.target.value)
                  : event.target.value.replace(".", ","),
            });
          }
        } else {
          setValuesInputsBorderoParcela({
            ...valuesInputsBorderoParcela,
            [prop]: event.target.value,
          });
        }
      };

  return (
    <Box sx={{ margin: 0, padding: 0 }}>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <AppTextField
            fullWidth
            label="Data recebimento *"
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
            type="date"
            value={valuesInputsBorderoParcela?.data_recebimento}
            variant="outlined"
            onChange={handleChange("data_recebimento")}
          />
        </Grid>
        <Grid item xs={5}>
          <AppTextField
            fullWidth
            label="Valor mensalidade do cliente *"
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
            value={valuesInputsBorderoParcela?.valor_recebido}
            variant="outlined"
            onChange={handleChange("valor_recebido", "money")}
          />
        </Grid>

        <Grid item xs={3}>
          <AppTextField
            fullWidth
            label="Vidas *"
            type="number"
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
            value={valuesInputsBorderoParcela.contratos_vidas}
            variant="outlined"
            onChange={handleChange("contratos_vidas")}
          />
        </Grid>

        <Grid item xs={5}>
          <AppTextField
            fullWidth
            label="Desconto na parcela do cliente"
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
            value={valuesInputsBorderoParcela?.desconto_parcela}
            variant="outlined"
            onChange={handleChange("desconto_parcela", "money2")}
          />
        </Grid>
        <Grid item xs={2}>
          <AppTextField
            fullWidth
            select
            label="Desconto"
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
            value={valuesInputsBorderoParcela?.tipo_desconto_parcela}
            variant="outlined"
            onChange={handleChange("tipo_desconto_parcela")}
          >
            <MenuItem value="PERCENTUAL">%</MenuItem>
            <MenuItem value="VALOR">R$</MenuItem>
          </AppTextField>
        </Grid>
        <Grid item xs={5}>
          <AppTextField
            fullWidth
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
            value={valuesInputsBorderoParcela.total_com_desconto}
            variant="outlined"
            title="Valor de base para calcular as %"
            label="Valor de base para calcular as %"
            disabled
          />
        </Grid>

        <Grid item xs={12}>
          <AppTextField
            fullWidth
            label="Observação"
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
            value={valuesInputsBorderoParcela.observacao}
            variant="outlined"
            onChange={handleChange("observacao")}
          />
        </Grid>
      </Grid>

      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", margin: "12px 0", minwWidth: "100%" }}>
        <Switch onChange={handleChangeChecked} checked={checked} />
        <Divider sx={{ width: "480px" }} />
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={3}>
          <AppTextField
            fullWidth
            label="Valor do escritório"
            variant="outlined"
            disabled={!checked}
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
            value={valuesInputsBorderoParcela.valor_comissao_corretora}
            onChange={handleChange("valor_comissao_corretora", "money")}
          />
        </Grid>
        <Grid item xs={3}>
          <AppTextField
            fullWidth
            label="Valor do corretor"
            variant="outlined"
            disabled={!checked}
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
            value={valuesInputsBorderoParcela.valor_comissao_corretor}
            onChange={handleChange("valor_comissao_corretor", "money")}
          />
        </Grid>
        <Grid item xs={3}>
          <AppTextField
            fullWidth
            label="Valor do supervisor"
            variant="outlined"
            disabled={!checked || !valuesInputsBorderoParcela.id_supervisor}
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
            value={valuesInputsBorderoParcela.valor_comissao_supervisor}
            onChange={handleChange("valor_comissao_supervisor", "money")}
          />
        </Grid>
        <Grid item xs={3}>
          <AppTextField
            fullWidth
            label="Valor do gerente"
            variant="outlined"
            disabled={!checked || !valuesInputsBorderoParcela.id_gerente}
            sxStyle={{ opacity: "", pointerEvents: "auto", margin: 0 }}
            value={valuesInputsBorderoParcela.valor_comissao_gerente}
            onChange={handleChange("valor_comissao_gerente", "money")}
          />
        </Grid>

        {checked && (
          <Grid item xs={12}>
            < CardAlerts
              title="Valor de pagamento personalizado !"
              subTitle="Se o valor da corretora/pagamentos for personalizado, o porcentagem(%) da comissão será recalculado baseado no valor da corretora/pagamentos !"
              color="primary"
              icon={<InfoOutlinedIcon fontSize="small" />}
            />
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
